import _ from 'lodash';

export const getClosestThumbnail = (thumbnails, width, height) => {
  if (!thumbnails) {
    return null;
  }
  let biggerImages = thumbnails.filter(
    thumbnail => thumbnail.width >= width && thumbnail.height >= height
  );
  let sortedImages = _.sortBy(
    biggerImages,
    thumbnail => thumbnail.width * thumbnail.height
  );
  return sortedImages.length ? sortedImages[0].image : null;
};

export const getClosestThumbnailAsBackground = (
  thumbnails,
  width,
  height,
  defaultImage
) => {
  let image = getClosestThumbnail(thumbnails, width, height);

  if (image === null) {
    image = _.get(defaultImage, 'image', null);
  }

  return !_.isNil(image) ? { backgroundImage: `url(${image})` } : {};
};
